  import React from "react";
  import "./Experience.css";
  import sse from './../images/sse.png';
  import w3soft from './../images/w3soft.png';
  import msnational from './../images/msnational.png';
  import cgg from './../images/cgg.png';

  const Experience = () => {
    const experienceData = [
      {
        title: "Software Developer",
        company: "Centre for Good Governance (CGG)",
        employmentType: "Full-time",
        location: "Hyderabad, Telangana, India · On-site",
        duration: "Sep 2025 – Present",
        description: `💻 Full Stack .NET Developer | ASP.NET Core MVC | Oracle | Dapper | Frontend & Backend Development<br/>
        I’m currently working as a .NET Developer at the Centre for Good Governance (CGG), contributing to a large-scale grievance management application.<br/><br/>
        My role spans both backend and frontend development — implementing secure APIs, business logic, and data access layers using Dapper with Oracle, while also designing responsive and user-friendly interfaces with Razor (.cshtml), JavaScript, and Bootstrap.<br/><br/>
        I focus on building maintainable modules, optimizing performance, and ensuring data accuracy across the workflow.<br/><br/>
        🔧 Tech Stack:<br/>
      ASP.NET Core MVC | C# | Dapper | Oracle | SQL Server | HTML5 | CSS3 | JavaScript | Bootstrap | Git | REST APIs<br/><br/>
      🚀 Passionate about delivering reliable, efficient, and user-focused enterprise applications.`,
        logo: cgg
      },
      {
        title: "Associate Software Engineer",
        company: "W3Softech India Private Limited",
        employmentType: "Full-time",
        location: "Hyderabad, Telangana, India · Hybrid",
        duration: "Jul 2023 – Sep 2025 · 2 yrs 3 mos",
        description: `💻 .NET Full Stack Developer | Web Development & Testing Enthusiast<br/>
      At W3Softech, I worked as a Full Stack Developer, contributing to multiple enterprise-grade web applications using ASP.NET Core, C#, Entity Framework, and SQL Server.<br/><br/>
      My role involved end-to-end development, including building responsive front-end interfaces, developing RESTful APIs, writing stored procedures, and integrating third-party services.<br/><br/>
      I also gained solid experience in software testing — performing unit, integration, and regression testing to ensure high-quality deliverables.<br/><br/>
      I actively collaborated with cross-functional teams in Agile sprints, focused on improving performance, maintainability, and scalability of .NET applications.<br/><br/>
      🔧 Tech Stack:<br/>
      ASP.NET Core | C# | SQL Server | Entity Framework | JavaScript | ReactJS | HTML5 | CSS3 | Bootstrap | Git | Postman | Unit Testing<br/><br/>
      📈 Strengthened my foundation in full-stack development and enterprise software practices.`,
        logo: w3soft
      },
      {
        title: "Engineer",
        company: "Shirdi Sai Electricals Ltd",
        employmentType: "Full-time",
        location: "Cuddapah, Andhra Pradesh, India · On-site",
        duration: "Dec 2019 – Jul 2023 · 3 yrs 6 mos",
        description: `Engineer | SAP PP End User | .NET Developer | Web Development<br/><br/>

Engineer with 2+ years of experience in manufacturing and IT solutions, combining hands-on exposure to SAP PP end-user activities with .NET development and web application building.<br/><br/>

SAP PP (End User): Experienced in updating reports, monitoring production orders, managing material movements, and supporting day-to-day production planning in a fabrication plant environment.<br/><br/>

Production Planning: Coordinated with shop-floor teams to align schedules, track progress, and ensure timely delivery of fabricated components.<br/><br/>

.NET Development (1.6 years): Developed and maintained an internal Attendance Management System, improving workforce tracking and reporting efficiency.<br/><br/>

Web Development: Built functional websites with focus on usability and performance for internal and external needs.`,
        logo:sse
      },
      {
        title: "Executive",
        company: "MS National Engineering",
        employmentType: "Full-time",
        location: "Cuddapah, Andhra Pradesh, India · On-site",
        duration: "Mar 2019 – Dec 2019 · 9 mos",
        description: `👷‍♂️ Executive – Manpower Recruitment & Training | Fabrication Industry | MS National Engineering<br/><br/>Worked as an Executive at MS National Engineering, where I led the complete recruitment and onboarding process for over 1000+ skilled and unskilled workers including welders, fitters, and machine operators.<br/>I partnered closely with department heads to align manpower needs with production timelines, while ensuring safety, efficiency, and compliance across operations.<br/><br/>Key contributions included conducting technical screenings and trade tests, coordinating safety-focused onboarding, and developing structured training modules.<br/>I also managed vendor partnerships for certification programs and upskilling, helping to reduce attrition and improve workforce performance.<br/><br/>📌 Key Skills & Contributions:<br/>Recruitment (Skilled/Unskilled) | Technical Screening | Trade Tests | Onboarding Programs | Safety Training | Fabrication Best Practices | Workforce Planning | Vendor Coordination | Labor Law Compliance | Performance Tracking<br/><br/>🏆 Achievements:<br/>✔️ Reduced hiring turnaround time by 30%<br/>✔️ Designed training modules boosting worker efficiency and safety<br/>✔️ Onboarded 1000+ personnel with zero production downtime`,
        logo:msnational
      },
    ];

    return (
      <section id="experience" className="experience-section">
        <h2 className="section-title">Experience</h2>
        <div className="experience-container">
          {experienceData.map((exp, index) => (
            <div key={index} className="experience-item">
              <div className="experience-header">
                <img src={exp.logo} alt={`${exp.company} logo`} className="company-logo" />
                <div>
                  <h2>{exp.title}</h2>
                  <p className="company">{exp.company} · {exp.employmentType}</p>
                  <p className="duration">{exp.duration}</p>
                  <p className="location">{exp.location}</p>
                </div>
              </div>
              <div className="experience-details">
                <p dangerouslySetInnerHTML={{ __html: exp.description }}></p>
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  };

  export default Experience;
